import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconEco(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        id: "Icon-eco_svg__filled",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M26,19a1,1,0,0,0-1,1V45a1,1,0,0,0,2,0V20A1,1,0,0,0,26,19Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M19.18,7.98C12.7148,4.2461,5.1885,6.9453,4.87,7.0615a1.0005,1.0005,0,0,0-.64,1.1084c.0576.333,1.4843,8.2012,7.9492,11.9346a10.2555,10.2555,0,0,0,5.1621,1.5107,7.8666,7.8666,0,0,0,2.0752-.2724A7.0523,7.0523,0,0,0,22.804,19.31l-11.16-6.4435a1,1,0,1,1,1-1.7324L23.8,17.575C24.5582,15.2043,24.255,10.91,19.18,7.98Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M47.13,7.0439c-.3184-.1171-7.8467-2.8134-14.31.918-5.0753,2.93-5.3785,7.2249-4.62,9.5955l11.1563-6.4412a1,1,0,1,1,1,1.7324L29.2085,19.2849a7.3752,7.3752,0,0,0,5.4575,2.3225A10.2876,10.2876,0,0,0,39.82,20.0859c6.4649-3.7324,7.8916-11.6,7.9492-11.9336A1.0006,1.0006,0,0,0,47.13,7.0439Z"
      })));
    }
  }));
}
export default SvgIconEco;